var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__marketplace"},[(_vm.isUniversalLoading)?_c('loading'):_vm._e(),_c('navbar'),_c('market-place')],1)}
var staticRenderFns = []

export { render, staticRenderFns }